/*******************************************************************************
 * Copyright (c) 2024. dnote.ai
 *
 * @project DNOTE.AI-Frontend
 * @author dnote.ai
 * @copyright Dnote.ai All rights reserved
 ******************************************************************************/

export const GENERAL_PLANS = [
    {label:"Login Modes - SMS" ,value:"LOGIN_SMS"},
    {label:"No. Of SMS" ,value:"SMS_SENDING"},
    {label:"No. Of WhatsApp" ,value:"WHATSAPP"},
    {label:"Custom Receipt" ,value:"CUSTOM_RECEIPT"},
    {label:"Custom Organization Logo" ,value:"CUSTOM_ORGANIZATION_LOGO"},
    {label:"Communication" ,value:"COMMUNICATION"},
    {label:"Address Printing Multi printer Option" ,value:"ADDRESS_PRINTING_MULTI_PRINTER_OPTION"},
    {label:"Existing Partner Import" ,value:"IMPORT_EXISTING_PARTNER"},
    {label:"Super Access - AI Feature" ,value:"AI_FEATURES"},
    {label:"Custom Reply Email" ,value:"CUSTOM_REPLY_EMAIL"},
    {label:"White Label" ,value:"WHITE_LABEL"},
    {label:"Partner Login" ,value:"PARTNER_LOGIN"},
    {label:"Multi-credit Account" ,value:"MULTI_CREDIT_ACCOUNT"}, // Credit Account
    {label:"Accounts Integration" ,value:"ACCOUNTS_INTEGRATION"},
    {label:"Auto Report" ,value:"AUTO_REPORT"},
    {label:"Certificates", value:"CERTIFICATE"},
    {label:"Group(s)", value:"MEMBER_GROUPS"}

    /*
    {label:"Dashboard" ,value:"DASHBOARD"},
    {label:"Admin Portal" ,value:"ADMIN_PORTAL"},
    {label:"Manage Menu" ,value:"MANAGE_MENU"},
    {label:"Manage Organization" ,value:"MANAGE_ORGANIZATION"},
    {label:"All Upcoming Updates" ,value:"ALL_UPCOMING_UPDATES"},
    {label:"Member Count" ,value:"MEMBER_COUNT"},
    {label:"User Count" ,value:"USER_COUNT"},
    {label:"Activity Log" ,value:"ACTIVITY_LOG"},
    {label:"Two-Factor Authentication" ,value:"TWO_FACTOR_AUTHENTICATION"},

    {label:"Receipt Templates" ,value:"RECEIPT_TEMPLATES"},
    {label:"Dashboard Email Notifications" ,value:"DASHBOARD_EMAIL_NOTIFICATIONS"},
    {label:"Responsive WorkFlow" ,value:"RESPONSE_WORKFLOW"},
     */
]